import { useStore } from '@store';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button } from '@basic';
import { GoalModel, ToastType } from '@models';
import { setupForDark } from '@theme';

const GoalPromoteButton = ({
  goal,
  canPublish = false,
  onPublished = () => {}
}: {
  goal: GoalModel;
  canPublish?: boolean;
  onPublished?: () => void;
}) => {
  const { t } = useTranslation();

  const { publishGoal, setToast } = useStore((state) => ({
    publishGoal: state.publishGoal,
    setToast: state.setToast
  }));

  const onPublish = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    await publishGoal(goal.entityId)
      .then(() => {
        setToast({ message: t('toasts.goalPublished'), type: ToastType.SUCCESS });
        onPublished();
      })
      .catch(() => {
        setToast({ message: t('toasts.somethingWentWrong'), type: ToastType.ERROR });
      });
  };

  return (
    <>
      <div
        className={classNames(
          'flex flex-col items-center justify-center px-xl pt-xl pb-xxl gap-sm',
          'border-t-[1px]',
          setupForDark('border-primary bg-modal-primary'),
          'P2B'
        )}
      >
        <div className={classNames('flex flex-col items-center gap-md w-full')}>
          <Button
            onClick={onPublish}
            type='primary'
            size='medium'
            disabled={!canPublish}
            fullWidth={true}
          >
            {t('components.goalPromoteButton.publish')}
          </Button>
          {!canPublish && (
            <div
              className={classNames(
                'text-center',
                'pl-huge pr-huge',
                'P2R',
                setupForDark('text-tertiary'),
                'dk:px-0'
              )}
            >
              {t('components.goalPromoteButton.cannotPublish')}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GoalPromoteButton;
